import GridHeader from "./GridHeader";
import GridRow from "./GridRow";
import Pagination from "./Pagination";

function Grid({
  data,
  columns,
  columnsTemplate,
  pagination = false,
  page = 1,
  totalPages = 1,
  onPageChange,
  renderTestId,
}) {
  if (columns) {
    return (
      <div>
        <div className={`grid gap-2 ${columnsTemplate}`}>
          {data.length > 0 && (
            <GridHeader headers={columns.map((col) => col.header)} />
          )}
          {data.map((row, i) => (
            <GridRow
              key={row.id || i}
              testId={renderTestId(row)}
              cells={columns.map((col) =>
                col.render ? col.render(row) : row[col.key]
              )}
            />
          ))}
        </div>
        {pagination && totalPages > 0 && (
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        )}
      </div>
    );
  }

  return <div className={`grid gap-2 ${columnsTemplate}`}>{data}</div>;
}

export default Grid;
